import { useEffect, useState } from 'react';
import { graphqlRequest } from '../common/apiClient';
import { getIdTokenClaims } from '../common/auth';
import { EDITOR_ROLES, resolveReprocessRole } from '../utils/reprocess';

const MY_TENANT_ARCA_QUERY = `
  query MyTenantArca {
    myTenant {
      tenant_id
      my_role
      arca_validation_enabled
    }
  }
`;

function resolveArcaRole(claims, tenantRole) {
  const fromClaims = resolveReprocessRole(claims);
  if (fromClaims && EDITOR_ROLES.has(fromClaims)) {
    return fromClaims;
  }
  const fromTenant = (tenantRole || '').toLowerCase();
  if (fromTenant && EDITOR_ROLES.has(fromTenant)) {
    return fromTenant;
  }
  return fromClaims || fromTenant || 'reader';
}

export function useArcaFeature() {
  const [state, setState] = useState({
    enabled: false,
    role: 'reader',
    loading: true,
  });

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const claims = await getIdTokenClaims();
        let tenant = null;
        try {
          const data = await graphqlRequest(MY_TENANT_ARCA_QUERY);
          tenant = data?.myTenant;
        } catch {
          const data = await graphqlRequest(`
            query MyTenantArcaFallback {
              myTenant { tenant_id my_role }
            }
          `);
          tenant = data?.myTenant;
        }
        if (cancelled) return;
        const role = resolveArcaRole(claims, tenant?.my_role);
        setState({
          enabled: tenant ? (tenant.arca_validation_enabled ?? true) : false,
          role,
          loading: false,
        });
      } catch {
        if (!cancelled) {
          setState({ enabled: false, role: 'reader', loading: false });
        }
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  const canConstatar = EDITOR_ROLES.has(state.role);

  return { ...state, canConstatar };
};
